import type { MapStateToProps } from 'react-redux';
import { connect } from 'react-redux';
import { getNumberOfFormsSelectedInBatchTab } from 'state/selectors';
import type { AppState } from 'state/state.model';

import type { BatchToolbarMetadataOwnProps, BatchToolbarMetadataStateProps } from './BatchToolbarMetadata.models';

export const mapStateToProps: MapStateToProps<
  BatchToolbarMetadataStateProps,
  BatchToolbarMetadataOwnProps,
  AppState
> = (state: AppState, ownProps: BatchToolbarMetadataOwnProps): BatchToolbarMetadataStateProps => ({
  numberOfQuotesSelected: getNumberOfFormsSelectedInBatchTab(state, ownProps.tabId),
});

export const connectedBatchToolbarMetadata = connect<
  BatchToolbarMetadataStateProps,
  void,
  BatchToolbarMetadataOwnProps,
  AppState
>(mapStateToProps);
